/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Blog_TitleInputs */

const en_directory_rails_blog_title = /** @type {(inputs: Directory_Rails_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogs`)
};

const zh_directory_rails_blog_title = /** @type {(inputs: Directory_Rails_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博客`)
};

/**
* | output |
* | --- |
* | "Blogs" |
*
* @param {Directory_Rails_Blog_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_blog_title = /** @type {((inputs?: Directory_Rails_Blog_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Blog_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_blog_title(inputs)
	return zh_directory_rails_blog_title(inputs)
});
export { directory_rails_blog_title as "directory.rails.blog_title" }